import React from "react";
import { LoadioStoreFeaturedSectionTemplate } from "themes/administration/loadio/pages";
import { LoadioStoreFeaturedSectionViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";
import { observer } from "mobx-react";

@setCurrentView(
    (rootStore, componentProps) => new LoadioStoreFeaturedSectionViewStore(rootStore, componentProps),
    "loadioStoreFeaturedSectionViewStore"
)
@observer
class LoadioStoreFeaturedSection extends React.Component {
    render() {
        return <LoadioStoreFeaturedSectionTemplate {...this.props} />;
    }
}

export default LoadioStoreFeaturedSection;
